import { render, staticRenderFns } from "./PurchasesDeliveryViewLogs.vue?vue&type=template&id=001946b4"
import script from "./PurchasesDeliveryViewLogs.vue?vue&type=script&lang=js"
export * from "./PurchasesDeliveryViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports